// @ts-nocheck

import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../styled-components/dark';
import { withOpacity } from '../../../styled-components/dark/helpers';

const BORDER_RADIUS = 5; // em

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${withOpacity(theme.KLOrientationPagination.backgroundColor, '99')};
  border-radius: ${BORDER_RADIUS}em;
  width: fit-content;

  &:before {
    content: '';
    position: absolute;
    width: 33%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 0;
    border-radius: ${BORDER_RADIUS}em;
    transition: none 200ms ease-in-out;
    transition-property: transform, background-color;

    ${({ $index, $lost }) => {
      if (typeof $index === 'number') {
        return css`
          transform: translateX(${$index * 100}%);
          background-color: ${theme.KLOrientationPagination.zoneSelector.backgroundColorDefault};
          background-color: ${$lost ? theme.KLOrientationPagination.zoneSelector.backgroundColorLost : undefined};
        `;
      }
    }}
  }
`;

const Zone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: bold;
  font-family: 'BettingArchivoNarrow';
  z-index: 1;
  padding: 0em 1em;
  transition: color 200ms ease-in-out;

  ${({ $selected, $disabled, $lost }) => {
    return css`
      color: ${theme.KLOrientationPagination.zoneLabel.colorDefault};
      color: ${$selected ? theme.KLOrientationPagination.zoneLabel.colorSelectedDefault : undefined};
      color: ${$lost ? theme.KLOrientationPagination.zoneLabel.colorLost : undefined};
      color: ${$disabled ? theme.KLOrientationPagination.zoneLabel.colorDisabled : undefined};

      cursor: ${!$selected && !$disabled ? 'pointer' : undefined};
      pointer-events: ${$selected || $disabled ? 'none' : undefined};
    `;
  }}
`;

type KLOrientationPaginationProps = {
  className?: string;
  index: number;
  progressionIndex: number;
  setIndex: (index: number) => void;
};

const KLOrientationPagination = ({
  className = '',
  index,
  progressionIndex,
  setIndex,
}: KLOrientationPaginationProps) => {
  const isZoneDisabled = useCallback((zoneIndex) => zoneIndex > progressionIndex, [progressionIndex]);
  const isZoneSelected = useCallback((zoneIndex) => zoneIndex === index, [index]);
  const isZoneLost = useCallback((zoneIndex) => zoneIndex < progressionIndex, [progressionIndex]);

  return (
    <Wrapper className={className} $index={index} $lost={isZoneLost(index)}>
      {['A', 'B', 'C'].map((keyValue, i) => (
        <Zone
          key={`zone-${keyValue}-tab`}
          onClick={() => setIndex(i)}
          $selected={isZoneSelected(i)}
          $disabled={isZoneDisabled(i)}
          $lost={isZoneLost(i)}
        >{`Zone ${keyValue}`}</Zone>
      ))}
    </Wrapper>
  );
};

export default KLOrientationPagination;
